import React from "react";
import { Link } from "react-router-dom";

const GetInTouch = () => {
    return (
        <div className="text-center ms-5 mt-5 pt-5">
            <p className="service-title mb-3">So, What are you waiting for?</p>
            <h5>
                Fell free to drop a massage. I will contact with you as soon as
                possible.
            </h5>
            <div className="text-center mt-5">
                <Link to="/contact">
                    <button className="button">Send Me a Message</button>
                </Link>
            </div>
        </div>
    );
};

export default GetInTouch;
